import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MEDIA = '(min-width: 48em)';

const View = styled.div`
    margin: 0 16px 12px;
    display: inline-block;
    cursor: pointer;

    @media ${MEDIA} {
        margin: 0;
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    color: #5c5c5c;
`;

const Image = styled.img`
    padding-right: 12px;
`;

const Label = styled.span`
    font-size: 14px;
`;

const Box = styled.span`
    width: 25px;
    height: 25px;

    border: 1px solid #5c5c5c;
    border-radius: 50%;
    display: inline-block;
`;

const Checkbox = props => {
    return (
        <View
            className={props.className}
            onClick={e => props.onClick(props.name, e)}
        >
            <Container>
                <Image src={props.imageSrc} />
                <Box>
                    {props.checked && (
                        <svg
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.06 15.1l-4.38-4.04-1.36 1.48 6.06 5.57L18.82 7.6l-1.64-1.16"
                                fillRule="nonzero"
                                fill="currentColor"
                            />
                        </svg>
                    )}
                </Box>
            </Container>
            <Label>{props.label}</Label>
        </View>
    );
};

Checkbox.propTypes = {
    imageSrc: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    checked: PropTypes.bool,
    onClick: PropTypes.func,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/shared/Checkbox.js